'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formComponents = undefined;

var _styledComponents = require('styled-components');

var _reactSelect = require('react-select/dist/react-select.css');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _Checkboxes = require('./Checkboxes');

var _Checkboxes2 = _interopRequireDefault(_Checkboxes);

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _MonthPicker = require('./MonthPicker');

var _MonthPicker2 = _interopRequireDefault(_MonthPicker);

var _NumberInput = require('./NumberInput');

var _NumberInput2 = _interopRequireDefault(_NumberInput);

var _RadioButtons = require('./RadioButtons');

var _RadioButtons2 = _interopRequireDefault(_RadioButtons);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Textarea = require('./Textarea');

var _Textarea2 = _interopRequireDefault(_Textarea);

var _Matrix = require('./Matrix');

var _Matrix2 = _interopRequireDefault(_Matrix);

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

var _Table = require('./Table');

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _styledComponents.injectGlobal)(_reactSelect2.default);

var formComponents = exports.formComponents = {
    input: {
        text: _Input2.default,
        mltext: _Textarea2.default,
        number: _NumberInput2.default,
        date: _DatePicker2.default,
        month_year: _MonthPicker2.default
    },
    select: {
        dropdown: _Select2.default,
        single: _RadioButtons2.default,
        multiple: _Checkboxes2.default
    },
    matrix: _Matrix2.default,
    table: _Table2.default,
    default: (0, _withFieldWrapper2.default)()
};